import axios from '../axios'
// import setLoading from '@/util/global'
// const invalid = ['/demo']
const invalid = []
const checkPage = function (url, next) {
  let _url = `${window.location.protocol}//${window.location.host}${window.location.pathname}#${url}`
  if (invalid.indexOf(url) === -1) {
    next()
  } else {
    // setLoading(true)
    axios.pageInvalidIf(_url).then(res => {
      // setLoading(false)
      if (res.data.body['404']) {
        location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}#/invalidPage`
      } else {
        next()
      }
    })
  }
}
export default checkPage


// WEBPACK FOOTER //
// ./src/util/invalidPage.js